<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;display: flex;justify-content: space-between;align-items: center;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				我的消息
			</div>
			<span style="margin-right: 20px;font-size: 18px;cursor: pointer;color:#888" @click="setAllRead">全部已读</span>
		</div>
		<div class="checkBox">
			<div @click="activeCheck = 1" :class="activeCheck == 1 ? 'checkActive':''">系统消息</div>
			<div @click="activeCheck = 2,answerMsg = [],answerCode = '',answerText = ''"
				:class="activeCheck == 2 ||activeCheck == 3 ? 'checkActive':''">站内信</div>
			<div @click="activeCheck = 4" :class="activeCheck == 4 ? 'checkActive':''">岗位邀请</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 1">
			<div v-if="systemNoticeList.total">
				<div class="pinglun" v-for="(item,index) in systemNoticeList.data">
					<div class="tophead">
						<div>
							<div v-if="item.is_read == 1" class="read">已读</div>
							<div v-else class="read" style="color: #888;">未读</div>
							<p>{{item.title}}</p>
						</div>
						<div>
							<div v-if="item.is_read == 0" @click="readed(item)" class="caozuo">标记为已读</div>
							<div class="caozuo" @click="delMsg(item,index)">删除</div>
						</div>
					</div>
					<div class="content">
						<div :class="'collapse'" :style="item.zhedie ?
						'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;'
						:''">
							{{item.content}}
						</div>
						<div v-if="item.content.length > 80" style="float: right;cursor: pointer;margin-top: 8px;"
							@click='item.zhedie = !item.zhedie'>

							<div v-if="item.zhedie">展开 <i class="el-icon-caret-bottom"></i></div>
							<div v-else>收起 <i class="el-icon-caret-top"></i></div>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" @current-change='systemCurrentChange'
						:page-size="systemNoticeList.per_page" :total="systemNoticeList.total">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200" description="暂无消息"></el-empty>
			</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 2">
			<div v-if="letterList.total">
				<div v-for="(item,index) in letterList.data">
					<div v-if="item.create_user_id == $store.state.userInfo.id" class="SXpinglun">

						<div class="userInfo">
							<div style="width: 78px;height: 78px;border-radius: 50%;overflow: hidden;">
								<img  @click="goto(`/geniusClub/geniusInfo?id=`+item.receive_user_id)"  :src='getImgSrc(item.create_user_id == $store.state.userInfo.id ? item.receive_avatar : item.create_avatar )'
									style="width: 100%;height: 100%;" alt="">
							</div>
						</div>
						<div class="content">

							<div style="display: flex;justify-content: space-between;">
								<div style="display: flex;align-items: flex-start;">
									<p @click="goto(`/geniusClub/geniusInfo?id=`+item.receive_user_id)" style="font-size: 18px;color: black;">
										{{item.create_user_id == $store.state.userInfo.id ? item.receive_nickname : item.create_nickname}}
									</p>
									<div v-if="item.weidu_count"
										style="background: red;width:15px;height: 15px;border-radius: 50%;color: #fff;text-align: center;line-height: 15px;font-size: 13px;margin-left: 10px;">
										{{item.weidu_count}}
									</div>
								</div>
								<div style="display: flex;">

									<div class="caozuo" @click="toAnswer(item)">查阅</div>
									<div class="caozuo" @click="toAnswer(item)">回复</div>
								</div>
							</div>

							<p style="font-size: 14px;margin-top: 10px;">{{timeConversion(item.createtime)}}</p>
							<div :class="'collapse'" :style="item.collapse ?
							'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;'
							:''">
								{{item.content}}
							</div>
							<div v-if="item.content.length > 80" style="float: right;cursor: pointer;margin-top: 8px;"
								@click='item.collapse = !item.collapse'>
								<div v-if="item.collapse.length">展开 <i class="el-icon-caret-bottom"></i></div>
								<div v-else>收起 <i class="el-icon-caret-top"></i></div>
							</div>
						</div>
					</div>
					<div v-else class="SXpinglun">
						<div class="userInfo">
							<div  @click="goto(`/geniusClub/geniusInfo?id=`+item.create_user_id)"  style="width: 78px;height: 78px;border-radius: 50%;overflow: hidden;">
								<img :src='getImgSrc(item.create_avatar)' style="width: 100%;height: 100%;" alt="">
							</div>
						</div>
						<div class="content">

							<div style="display: flex;justify-content: space-between;">
								<div  @click="goto(`/geniusClub/geniusInfo?id=`+item.create_user_id)"  style="display: flex;align-items: flex-start;">
									<p style="font-size: 18px;color: black;">{{item.create_nickname}}</p>
									<div v-if="item.weidu_count"
										style="background: red;width:15px;height: 15px;border-radius: 50%;color: #fff;text-align: center;line-height: 15px;font-size: 13px;margin-left: 10px;">
										{{item.weidu_count}}
									</div>
								</div>
								<div style="display: flex;">
									<div class="caozuo" @click="toAnswer(item)">查阅</div>
									<div class="caozuo" @click="toAnswer(item)">回复</div>
								</div>
							</div>

							<p style="font-size: 14px;margin-top: 10px;">{{timeConversion(item.createtime)}}</p>
							<div :class="'collapse'" :style="item.collapse ?
							'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;text-overflow: ellipsis;'
							:''">
								{{item.content}}
							</div>
							<div v-if="item.content.length > 80" style="float: right;cursor: pointer;margin-top: 8px;"
								@click='item.collapse = !item.collapse'>
								<div v-if="item.collapse">展开 <i class="el-icon-caret-bottom"></i></div>
								<div v-else>收起 <i class="el-icon-caret-top"></i></div>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" @current-change='letterCurrentChange'
						:page-size="letterList.per_page" :total="letterList.total">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200" description="暂无消息"></el-empty>
			</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 4">
			<div v-if="inviteList.total">
				<div class="pinglun" v-for="(item,index) in inviteList.data">
					<div class="tophead" style="display: flex;justify-content: space-between;">
						<div>
							<div style="padding: 0 10px;width: auto;" class="read">{{item.company_name}}</div>

							<p>{{item.job_name}}</p>
							<div style="display: flex;" v-if="item.status == 1">
								<div class="caozuo" @click="agreeOrDenyHandler(item,2)">同意</div>
								<div class="caozuo" @click="agreeOrDenyHandler(item,3)">拒绝</div>
							</div>
							<div style="color: #666;margin-left: 15px;" v-if="item.status == 2">
								已同意
							</div>
							<div style="color: #666;margin-left: 15px;" v-if="item.status == 3">
								已拒绝
							</div>
							<div style="color: #666;margin-left: 15px;" v-if="item.status == 4">
								已失效
							</div>
						</div>
						<div>
							<!-- <div v-if="item.is_read == 0" @click="readed(item)" class="caozuo">标记为已读</div>
							<div class="caozuo" @click="delMsg(item,index)">删除</div> -->
						</div>
					</div>
					<div class="content" style="word-break: break-word">
						<div :class="'collapse'">
							{{item.msg}}
						</div>

					</div>
				</div>
				<div style="width: 100%; margin-top:auto; padding:20px ;display: flex;justify-content: center;">
					<el-pagination background layout="prev, pager, next" @current-change='getjobInviteList'
						:page-size="inviteList.per_page" :total="inviteList.total">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200" description="暂无消息"></el-empty>
			</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="activeCheck == 3">
			<div class="SXpinglun" v-for="(item,index) in chatLog">
				<div class="userInfo">
					<div style="width: 78px;height: 78px;border-radius: 50%;overflow: hidden;">
						<img :src='getImgSrc(item.avatar)' style="width: 100%;height: 100%;" alt="">
					</div>
				</div>
				<div class="content">
					<div style="display: flex;justify-content: space-between;">
						<p style="font-size: 18px;color: black;">
							{{item.nickname}}
						</p>
						<div style="display: flex;">
							<div class="caozuo" style="color: #0052D9;" @click="delLetter(item)">删除</div>
						</div>
					</div>

					<p style="font-size: 14px;margin-top: 10px;">{{timeConversion(item.createtime)}}</p>
					<div :class="'collapse'" style="color: #222;">
						{{item.content}}
					</div>

				</div>
			</div>
			<div>
				<el-input type="textarea" resize='none' placeholder="请输入内容" v-model="sendInfo.content">
				</el-input>
				<div style="display: flex;margin-top: 20px;align-items: center;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<input type="text" v-model.trim='sendInfo.code'
							style="width: 133px;height: 40px;border: 1px solid #D2D2D2;font-size: 18px;">
						<div
							style="width: 90px;height: 40px;background: #D2D2D2;border: 1px solid #D2D2D2;text-align: center;line-height: 32px;cursor: pointer;">
							<img :src="yzImg" alt="" style="width: 100%;height: 100%;" @click="getYzImg">
						</div>
					</div>
					<div @click="sendMsg"
						style="width: 52px;height: 24px;background: #E5EDFB;border-radius: 5px;color: #0052D9;line-height: 24px;text-align: center;cursor: pointer;">
						发送
					</div>
				</div>
			</div>
		</div>
		<div style="padding: 25px; box-sizing: border-box;" v-if="$route.query.tyep">
			<div class="SXpinglun" v-for="(item,index) in answerMsg">
				<div class="userInfo">
					<div  style="width: 78px;height: 78px;border-radius: 50%;overflow: hidden;">
						<img src='../../../assets/images/erciyuan.png' style="width: 100%;height: 100%;" alt="">
					</div>
				</div>
				<div class="content">
					<div style="display: flex;justify-content: space-between;">
						<p style="font-size: 18px;color: black;">用户昵称123123</p>
						<div style="display: flex;">
							<div class="caozuo" v-if="item.origin" style="color: #0052D9;" @click="delLetter(item)">删除
							</div>
						</div>
					</div>

					<p style="font-size: 14px;margin-top: 10px;">{{item.data}}</p>
					<div :class="'collapse'" style="color: #222;">
						{{item.content}}
					</div>

				</div>
			</div>
			<div>
				<el-input type="textarea" resize='none' placeholder="请输入内容" v-model.trim="answerText">
				</el-input>
				<div style="display: flex;margin-top: 20px;align-items: center;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<input type="text" v-model.trim='answerCode'
							style="width: 133px;height: 32px;border: 1px solid #D2D2D2;">
						<div
							style="width: 77px;height: 32px;background: #D2D2D2;border: 1px solid #D2D2D2;text-align: center;line-height: 32px;">
							{{serveAnswerCode}}
						</div>
					</div>
					<div @click="answer"
						style="width: 52px;height: 24px;background: #E5EDFB;border-radius: 5px;color: #0052D9;line-height: 24px;text-align: center;cursor: pointer;">
						发送
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import timeConversion from '../../../utils/timeConversion.js'
	export default {
		data() {
			return {
				activeCheck: 1,
				answerMsg: [{
					origin: true,
					data: 123,
					content: 'hello'
				}],
				answerText: '',
				answerCode: '',
				serveAnswerCode: 'ABCD',
				systemNoticeList: [],
				systemNoticePage: 1,
				letterList: [],
				letterPage: 1,
				chatLog: [],
				yzImg: '',
				sendInfo: {
					uniqid: '',
					receive_user_id: '',
					content: '',
					code: ''
				},
				inviteList: [],
				invitePage: 1,
				timer: null
			}
		},
		created() {
			if (this.$route.query.type) {
				this.activeCheck = this.$route.query.type
				this.getYzImg()
			}
			this.sendInfo.content = 'TO'+'+'+this.$route.query.zuozhe+'+'+this.$route.query.biaoti+'：';
			if (this.$route.query.id) {
				this.getChatLog()
				this.getYzImg()
			}
			this.getSystemNotice()
			this.getLetterList()
			this.getjobInviteList()
		},
		mounted() {
			this.timer = setInterval(() => {
				this.getSystemNotice()
				this.getLetterList()
				this.getjobInviteList()
			}, 15000)
		},
		watch: {
			'$route.query.type': {
				handler(n, o) {
					this.activeCheck = n
					// this.getYzImg()
				}
			}
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		methods: {
			goto(url) {
				this.$router.push(url)
				console.log('跳转',url);
			},
			async agreeOrDenyHandler(item, sta) {
				const handler = await this.$api.agreeOrDeny({
					id: item.id,
					status: sta
				})
				if (handler.code == 1) {
					this.$message({
						message: handler.msg,
						type: 'success'
					})
					if (sta == 2) {
						item.status = 2
					}
					if (sta == 3) {
						item.status = 3
					}
				} else {
					this.$message({
						message: handler.msg,
						type: 'warning'
					})
				}
			},
			async getjobInviteList(e) {
				if (e) {
					this.invitePage = e
				}
				const list = await this.$api.jobInviteList({
					page: this.invitePage
				})
				this.inviteList = list.data
			},
			async delLetter(item) {
				const letter = await this.$api.delUserLetter({
					id: item.id
				})
				if (letter.code == 1) {
					this.$message({
						message: letter.msg,
						type: 'success'
					})
					this.$store.dispatch('getNotReadMsg')
					if (item.location) {
						this.chatLog = this.chatLog.filter(log => log.id !== item.id)
					} else {
						this.letterList.data.filter(txt => txt.id !== item.id)
					}
					// this.systemNoticeList.data.splice(index, 1)
				} else {
					this.$message({
						message: letter.msg,
						type: 'warning'
					})
				}
			},
			async sendMsg() {
				console.log(this.$route.query.id, '!!!!!!!!!!!!!!!')
				this.sendInfo.receive_user_id = this.$route.query.id
				const send = await this.$api.sendMsgToPerson({
					...this.sendInfo
				})
				if (send.code == 1) {
					this.$message({
						message: send.msg,
						type: 'success'
					})
					// let date = new Date()
					let newMsg = {
						avatar: this.$store.state.userInfo.avatar,
						createtime: new Date() / 1000,
						content: this.sendInfo.content,
						nickname: this.$store.state.userInfo.nickname
					}
					this.chatLog.push(newMsg)
					this.sendInfo = {
						uniqid: '',
						receive_user_id: '',
						content: '',
						code: ''
					}
					this.getYzImg()
				} else {
					this.$message({
						message: send.msg,
						type: 'warning'
					})
				}
				console.log(send);
			},
			async getChatLog(item) {

				if (item.id) {
					const log = await this.$api.getPersonChatLog({
						user_id: item.create_user_id == this.$store.state.userInfo.id ? item.receive_user_id :
							item.create_user_id
					})
					this.chatLog = log.data

				} else {
					const log = await this.$api.getPersonChatLog({
						user_id: this.$route.query.id
					})
					this.chatLog = log.data
				}
			},
			async getYzImg() {
				const code = await this.$api.verifyCode()
				this.yzImg = code.data.src
				this.sendInfo.uniqid = code.data.uniqid
				console.log(code);
			},
			letterCurrentChange(e) {
				this.letterPage = e
				this.getLetterList()
			},
			systemCurrentChange(e) {
				this.systemNoticePage = e
				this.getSystemNotice()
			},
			async getLetterList() {
				const letter = await this.$api.getPrivateMsg({
					page: this.letterPage
				})
				let list = letter.data
				list.data.forEach(item => {
					item.collapse = true
				})
				this.letterList = list
			},
			async getSystemNotice() {
				const notice = await this.$api.getSystemNotice({
					page: this.systemNoticePage
				})
				let list = notice.data
				list.data.forEach(item => {
					item.zhedie = false
				})
				this.systemNoticeList = list
			},
			answer() {
				if (this.answerCode == '') {
					this.$message.error('请输入验证码')
					return
				}
				if (this.answerCode !== this.serveAnswerCode) {
					this.$message.error('验证码有误')
					return
				} else {
					if (this.answerText !== '') {
						let time = timeConversion(new Date())
						let ansewr = {
							origin: 1,
							data: time,
							content: this.answerText
						}
						this.answerMsg.push(ansewr)
						this.answerText = ''
						this.answerCode = ''
					}
				}
			},
			async toAnswer(item) {
				console.log(item);

				await this.$api.setLetterRead({
					create_user_id: item.create_user_id == this.$store.state.userInfo.id ? item
						.receive_user_id : item.create_user_id
				})
				this.activeCheck = 3
				this.$route.query.id = item.create_user_id == this.$store.state.userInfo.id ? item.receive_user_id :
					item.create_user_id
				item.weidu_count = 0
				this.getChatLog(item)
				this.getYzImg()
				this.$store.dispatch('getNotReadMsg')
				// let time = timeConversion(new Date())
				// console.log(time);
			},
			delAnswer(index) {
				this.answerMsg.splice(index, 1)
			},

			async delMsg(item, index) {
				const del = await this.$api.delSystemNotice({
					id: item.id
				})
				if (del.code == 1) {
					this.$message({
						message: del.msg,
						type: 'success'
					})
					this.systemNoticeList.data.splice(index, 1)
					this.$store.dispatch('getNotReadMsg')
				} else {
					this.$message({
						message: del.msg,
						type: 'warning'
					})
				}
			},
			async readed(item) {
				const read = await this.$api.setSystemNoticeRead({
					id: item.id
				})
				if (read.code == 1) {
					this.$message({
						message: read.msg,
						type: 'success'
					})
					item.is_read = 1
				} else {
					this.$message({
						message: read.msg,
						type: 'warning'
					})
				}
			},
			async setAllRead() {
				let read
				if (this.activeCheck == 1) {
					read = await this.$api.setSystemNoticeAllRead()
					if (read.code == 1) {
						this.systemNoticeList.data.forEach(item => item.is_read = 1)
					}
				} else if (this.activeCheck == 2) {
					read = await this.$api.setLetterAllRead()
				}
				if (read.code == 1) {
					this.$message({
						message: read.msg,
						type: 'success'
					})
					this.$store.dispatch('getNotReadMsg')
				} else {
					this.$message({
						message: read.msg,
						type: 'warning'
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.el-textarea__inner {
		color: #222;
		font-size: 16px;
		height: 184px;
		border: 1px solid #E5E5E5;
		font-family: none;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background: #0052D9;
	}

	.SXpinglun {
		.caozuo {
			background-color: #EEEEEE;
			color: #888;
			padding: 0 15px;
			margin-left: 15px;
			cursor: pointer;
		}

		.caozuo:hover {
			background-color: #5b5b5b;
			color: white;
		}

		.collapse {
			margin-top: 5px;
		}

		color: #909090;
		display: flex;
		align-items: flex-start;
		border-bottom: 1px dashed #eee;
		padding-bottom: 20px;
		margin-bottom: 30px;

		.content {
			margin-left: 28px;
			flex: 1;


			&>p {}
		}

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: center;

			p {
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.pinglun {
		.tophead {
			display: flex;
			justify-content: space-between;

			&>div {
				display: flex;

				.read {
					width: 49px;
					height: 24px;
					background-color: #E5EDFB;
					color: #0052D9;
					text-align: center;
					line-height: 24px;
					font-size: 18px;
				}

				.caozuo {
					background-color: #EEEEEE;
					color: #888;
					padding: 0 15px;
					margin-left: 15px;
					cursor: pointer;
				}

				.caozuo:hover {
					background-color: #5b5b5b;
					color: white;
				}

				&>p {
					margin-left: 15px;
					font-size: 18px;
					font-weight: bold;
				}
			}

		}

		.collapse {
			margin-top: 15px;
		}

		.content {
			color: #909090;
		}

		box-sizing: border-box;
		border-bottom: 1px dashed #eee;
		padding-bottom: 40px;
		margin-bottom: 30px;

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: flex-start;

			p {
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.checkBox {
		padding: 0 20px;
		font-size: 18px;
		display: flex;
		height: 80px;
		line-height: 80px;
		cursor: pointer;
		border-bottom: 1px solid #ECECEC;

		div {
			margin-right: 60px;
		}

		.checkActive {
			font-weight: bold;
			color: #0052D9;
			border-bottom: 5px solid #0052D9;
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 860px;
		box-sizing: border-box;
		background: #fff;
	}
</style>